import { render } from "./NavbarComponent.vue?vue&type=template&id=659d1444&scoped=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=js"
export * from "./NavbarComponent.vue?vue&type=script&lang=js"

import "./NavbarComponent.vue?vue&type=style&index=0&id=659d1444&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659d1444"]])

export default __exports__